var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7032 14.5327L16.6824 26.5535C13.9487 29.2872 9.51659 29.2872 6.78292 26.5535C4.04925 23.8198 4.04925 19.3877 6.78292 16.654L18.8037 4.63319C20.6262 2.81075 23.5809 2.81075 25.4034 4.63319C27.2258 6.45564 27.2258 9.41041 25.4034 11.2329L13.854 22.7823C12.9428 23.6935 11.4654 23.6935 10.5542 22.7823C9.64293 21.871 9.64293 20.3937 10.5542 19.4824L20.6894 9.34724",
    stroke: "#90A1B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAttachment);
export default __webpack_public_path__ + "static/media/ic_attachment.748c75dffa64dd3e48d9e3ee09fbe1f6.svg";
export { ForwardRef as ReactComponent };